module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/packges/packges.component.css
// module id = ./src/app/packges/packges.component.css
// module chunks = main